import NavBar from "./Components/NavBar";
import { BrowserRouter, Route ,Routes } from "react-router-dom";
import Home from "./Components/Home";
import Footer from "./Components/Footer";
import About from "./Components/About";
import Services from "./Components/Services";
import Career from "./Components/Career";
import ContactUs from "./Components/ContactUs";
import ScrollToTop from "./Components/ScrollToTop";



function App() {
  return (
    <div >
      <BrowserRouter>
      <ScrollToTop></ScrollToTop>

      <NavBar></NavBar>
      <Routes>

        <Route path="/" element={<Home></Home>}/>
        <Route path="/about-us" element={<About></About>}/>
        <Route path="/services" element={<Services></Services>}/>
        <Route path="/career" element={<Career></Career>}/>
        <Route path="/contact-us" element={<ContactUs></ContactUs>}/>

      </Routes>
      <Footer></Footer>
      </BrowserRouter>
    </div>
  );
}

export default App;
